<template>
    <div>
        <swb-query-sort-area ref="query_model" :config="queryConfig" :queryHandler="queryHandler"></swb-query-sort-area>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'
    //
    import SwbQuerySortArea from '../query/QuerySortArea';
    Vue.regist(SwbQuerySortArea);

    let searchConfigData = {
        "queryFields": [
            {
                "type": "Text",
                "label": "服务请求单号",
                "code": "no",
                "valueType": "String",
                "basic": true
            },
            {
                "type": "Text",
                "label": "服务号",
                "code": "svcNo",
                "basic": true,
                "valueType": "String"
            },
            {
                "type": "Text",
                "label": "零售商户",
                "code": "buyerName",
                "basic": true
            },
            {
                "type": "Text",
                "label": "零售门店",
                "code": "buyerShopName",
                "basic": true,
                "valueType": "String"
            },
            {
                "type": "Text",
                "label": "请求商户",
                "code": "srcMerchantName",
                "basic": true,
                "valueType": "String"
            },
            {
                "type": "Date2",
                "valueType": "String",
                "label": "请求时间",
                "code": "requestTime",
                "basic": false
            },
            {
                "type": "Select",
                "label": "已指派门店",
                "code": "servicerShopFlag",
                "valueType": "Boolean",
                "basic": false,
                "dataList": [
                    {
                        "value": null,
                        "label": "- 全部 -"
                    },
                    {
                        "value": "true",
                        "label": "是"
                    },
                    {
                        "value": "false",
                        "label": "否"
                    }
                ]
            },
            {
                "type": "Select",
                "label": "服务类型",
                "code": "servcType",
                "valueType": 'Integer',
                "basic": true,
                "dataList": []
            },
            {
                "type": "Select",
                "label": "已派工",
                "code": "svcDispatched",
                "valueType": "Boolean",
                "basic": false,
                "dataList": [
                    {
                        "value": null,
                        "label": "- 全部 -"
                    },
                    {
                        "value": "true",
                        "label": "是"
                    },
                    {
                        "value": "false",
                        "label": "否"
                    }
                ]
            }
        ],
        "sortFields": [
            {
                "label": "请求时间",
                "code": "requestTime",
                "order": "desc",
                "enabled": false
            }
        ]
    };

    export default {
        name: 'swb-servc-req-voucher-search',
        desc: '请求单综合管理搜索',
        data: function () {
            return {
                //排序、搜索
                queryConfig: null,
                queryKey: null
            }
        },
        created: function () {
            this.initQuery();
        },
        methods: {
            //
            initQuery: function () {
                //----------------------搜索排序----------------------------
                //查询排序配置信息
                let queryConfig = searchConfigData || {};
                //查询回调函数调用上下文对象
                //queryConfig.queryContext = this;
                let queryConfigMap = queryConfig.queryFields.toMap("code");
                let workServcTypeList = [{
                    value: null,
                    label: '- 全部 -'
                }];
                let workServcTypes = getEnumList("workServcType");
                if(workServcTypes != null && workServcTypes.length > 0) {
                    workServcTypes.forEach(function (item) {
                        let queryItem = {};
                        queryItem.value = item.value;
                        queryItem.label = item.text;
                        workServcTypeList.push(queryItem);
                    });
                }
                let workServcTypeListItem = queryConfigMap["servcType"];
                workServcTypeListItem.dataList = [];
                workServcTypeListItem.dataList = Utils.merge([], workServcTypeList);
                //
                this.queryConfig = queryConfig;
            },
            //
            queryHandler(queryModel) {
                //缓存查询条件
                this.$emit('showSearch', queryModel);
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/servcReq/ServcReqVoucherSearch.vue